import React, { useContext, useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  CircularProgress,
  // useTheme,
  // useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PermissionAlert from 'src/components/shared/PermissionAlert.jsx';
// import LockResetIcon from '@mui/icons-material/Lock';
import LockResetIcon from '@mui/icons-material/LockReset';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import { notify } from 'src/utils/notifyFunction.js';
import { sanitizeInput, isInputSafe } from 'src/utils/sanitizeInput';

import { UserContext } from '../../../Contexts/UserContext.jsx';
import { useHistory, Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import { DASHBOARD_URL, CHANGE_PASSWORD, BASIC_TOKEN_HEADER, FETCH_PASSWORD_POLICY } from '../../../constants/api.config.js';
import axios from 'axios';
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import GujGovComp from "../../../components/shared/GujGovComp";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import BG2 from "../../../assets/images/BG2.jpg"
import HomeIcon from '@mui/icons-material/Home';
import useBreakpoints from 'src/utils/Breakpoints';
import { getUserToken, globalLogoutFunction } from 'src/utils/handleCookie.js';
import { broadCastMessageHandler } from 'src/utils/handleCookie.js';
const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [openPermissionModal, setOpenPermissionModal] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  });
  const [policyLoading, setPolicyLoading] = useState(false);
  const [dynamicRegex, setDynamicRegex] = useState(null);
  const [policyConstraints, setPolicyConstraints] = useState({
    minLen: 8,
    maxLen: 16,
    minUppercase: 1,
    minLowercase: 1,
    minNumber: 1,
    minSpecial: 1
  });
  const theme = useTheme();
  const { isSm, isMd, isLg } = useBreakpoints();
  const { contextUserData } = useContext(UserContext)

  const history = useHistory()

  // Password validation function
  // Note: Special characters exclude SQL injection characters like quotes, semicolons, and hyphens
  const validatePassword = (password) => {
    const { minLen, maxLen, minUppercase, minLowercase, minNumber, minSpecial } = policyConstraints;

    const regexToUse =
      dynamicRegex ||
      /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*()_+\-=\[\]{}|:,.?]){1,})[a-zA-Z\d!@#$%^&*()_+\-=\[\]{}|:,.?]{8,16}$/;

    const isValid = regexToUse.test(password);

    const countMatches = (str, pattern) => {
      const m = str.match(new RegExp(pattern, 'g'));
      return m ? m.length : 0;
    };

    const validations = {
      length: password.length >= minLen && password.length <= maxLen,
      uppercase: countMatches(password, '[A-Z]') >= minUppercase,
      lowercase: countMatches(password, '[a-z]') >= minLowercase,
      number: countMatches(password, '\\d') >= minNumber,
      special: countMatches(password, '[!@#$%^&*()_+\\-=\\[\\]{}|:,.?]') >= minSpecial
    };


    setPasswordValidation(validations);
    return validations;
  };

  // Build regex and constraints from server policy
  const buildRegexFromPolicy = (policyMap) => {
    const yes = (v) => String(v || '').toUpperCase() === 'YES';

    const minLen = parseInt(policyMap.PP1_MIN_TOTAL_LEN || '8', 10);
    const maxLen = parseInt(policyMap.PP1_MAX_TOTAL_LEN || '16', 10);

    const requireUpper = yes(policyMap.PP2_IS_UPPERCASE);
    const requireLower = yes(policyMap.PP2_IS_LOWERCASE);
    const requireNum = yes(policyMap.PP2_IS_NUMBER);
    const requireSpl = yes(policyMap.PP2_IS_SPL_CHAR);

    const minUppercase = requireUpper ? parseInt(policyMap.PP2_MIN_LEN_UPPERCASE || '1', 10) : 0;
    const minLowercase = requireLower ? parseInt(policyMap.PP2_MIN_LEN_LOWERCASE || '1', 10) : 0;
    const minNumber = requireNum ? parseInt(policyMap.PP2_MIN_LEN_NUMBER || '1', 10) : 0;
    const minSpecial = requireSpl ? parseInt(policyMap.PP2_MIN_LEN_SPL_CHAR || '1', 10) : 0;

    const lookaheads = [];
    if (minUppercase > 0) lookaheads.push(`(?=(?:.*[A-Z]){${minUppercase},})`);
    if (minLowercase > 0) lookaheads.push(`(?=(?:.*[a-z]){${minLowercase},})`);
    if (minNumber > 0) lookaheads.push(`(?=(?:.*\\d){${minNumber},})`);
    if (minSpecial > 0) lookaheads.push(`(?=(?:.*[!@#$%^&*()_+\\-=\\[\\]{}|:,.?]){${minSpecial},})`);

    const allowedSet = '[a-zA-Z\\d!@#$%^&*()_+\\-=\\[\\]{}|:,.?]';
    const regex = new RegExp(`^${lookaheads.join('')}${allowedSet}{${minLen},${maxLen}}$`);

    setPolicyConstraints({ minLen, maxLen, minUppercase, minLowercase, minNumber, minSpecial });
    setDynamicRegex(regex);
  };
  const fetchPolicy = async () => {
    try {
      setPolicyLoading(true);
      const divisionCode = contextUserData?.Ref_DivisionID;
      const loginId = getUserToken();
      if (!divisionCode || !loginId) return;
      const params = new URLSearchParams({
        DivisionCode: divisionCode,
        LoginID: loginId,
      });

      const config = {
        method: 'GET',
        url: `${DASHBOARD_URL}/${FETCH_PASSWORD_POLICY}?${params.toString()}`,
        headers: BASIC_TOKEN_HEADER
      };

      const res = await axios(config);

      const links = res?.data?.Links || res?.data?.d?.Links || [];
      const policyMap = {};
      links.forEach((item) => {
        policyMap[item.Key] = item.Value;
      });
      buildRegexFromPolicy(policyMap);
    } catch (err) {
      console.error('Failed to fetch password policy', err);
    } finally {
      setPolicyLoading(false);
    }
  };

  async function broadcastMessageFettcher() {


    const tempcurrentMessage = await broadCastMessageHandler()
    if (tempcurrentMessage) {
      if (tempcurrentMessage === "LOGOUT") {
        history.push("/login")
      }
      else if (tempcurrentMessage !== "LOGOUT") {
        return
      }
    }

  }


  // Fetch password policy from server
  useEffect(() => {
    fetchPolicy();
    broadcastMessageFettcher()
  }, []);

  // Update validation when newPassword changes
  useEffect(() => {
    if (newPassword) {
      validatePassword(newPassword);
    } else {
      setPasswordValidation({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false
      });
    }
  }, [newPassword]);

  const handleReset = () => {
    setOldPassword("")
    setNewPassword("")
    setRepeatPassword("")
    setPasswordValidation({
      length: false,
      uppercase: false,
      lowercase: false,
      number: false,
      special: false
    });
  }

  const handleSubmit = async () => {

    setLoading(true);

    // Input validation
    if (!isInputSafe(oldPassword) || !isInputSafe(newPassword) || !isInputSafe(repeatPassword)) {
      notify("Invalid input detected!", "error");
      setLoading(false);
      return;
    }
    const safeOldPassword = sanitizeInput(oldPassword);
    const safeNewPassword = sanitizeInput(newPassword);
    const safeRepeatPassword = sanitizeInput(repeatPassword);

    if (oldPassword === newPassword) { notify("old password and new password can not be same", "error"); setLoading(false); return }
    if (newPassword !== repeatPassword) { notify("passwords doesn't match", "error"); setLoading(false); return }

    // Check if password meets all requirements using dynamic regex (fallback to default)
    const passwordRegex =
      dynamicRegex ||
      /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*()_+\-=\[\]{}|:,.?]){1,})[a-zA-Z\d!@#$%^&*()_+\-=\[\]{}|:,.?]{8,16}$/;
    if (!passwordRegex.test(newPassword)) {
      notify("Password does not meet all requirements!", "error");
      setLoading(false);
      return;
    }

    if (!contextUserData?.UserID) {

      await globalLogoutFunction()

      history.push("/login")
      return
    }
    const params = new URLSearchParams({
      // UserCode: contextUserData?.UserID.trim(),
      UserCode: getUserToken(),
      OldPassword: safeOldPassword,
      NewPassword: safeNewPassword,

    });

    const config = {
      method: 'GET',
      url: `${DASHBOARD_URL}/${CHANGE_PASSWORD}?${params.toString()}`,
      headers: BASIC_TOKEN_HEADER
    };

    try {
      const result = await axios(config);
      const { ErrCode, ErrMsg } = result.data.ErrMsg[0];
      if (ErrCode === "1") {


        notify(ErrMsg, "success");
        // localStorage.clear()
        await globalLogoutFunction()
        history.push("/login")

      } else if (ErrCode === "-1") {
        notify(ErrMsg, "error");
      }

      // else if (ErrCode === "1" && ErrMsg.includes("Incorrect Old Password")) {
      //   notify("Incorrect Old Password", "error");
      // }
      // else if (ErrCode === "1" && ErrMsg.includes("Maximum attempts")) {
      //   notify("Maximum Attempts Reached", "error");
      // }
      // else if (ErrCode === "1" && ErrMsg.includes("Your Password Has been Changed")) {


      // }
    } catch (error) {
      notify("Server Error", "error");
    } finally {
      setLoading(false);
    }
  };

  // Password validation rules component
  const PasswordValidationRules = () => (
    <Box sx={{ mt: 0, mb: 0 }}>
      <Typography
        variant="h6"
        color="primary"
        sx={{
          mb: 2,
          fontWeight: 'bold',
          textAlign: 'center',
          borderBottom: '2px solid',
          borderColor: 'primary.main',
          pb: 1
        }}
      >
        Password Requirements
      </Typography>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.2,
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 1,
          borderRadius: 1,
          backgroundColor: passwordValidation.length ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)'
        }}>
          {passwordValidation.length ? (
            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, flexShrink: 0 }} />
          ) : (
            <CancelIcon sx={{ color: 'red', fontSize: 20, flexShrink: 0 }} />
          )}
          <Typography
            variant="body2"
            sx={{
              color: passwordValidation.length ? 'green' : 'red',
              fontWeight: passwordValidation.length ? 'bold' : 'normal',
              lineHeight: 1.4
            }}
          >
            Length: {policyConstraints.minLen}-{policyConstraints.maxLen} characters
          </Typography>
        </Box>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 1,
          borderRadius: 1,
          backgroundColor: passwordValidation.uppercase ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)'
        }}>
          {passwordValidation.uppercase ? (
            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, flexShrink: 0 }} />
          ) : (
            <CancelIcon sx={{ color: 'red', fontSize: 20, flexShrink: 0 }} />
          )}
          <Typography
            variant="body2"
            sx={{
              color: passwordValidation.uppercase ? 'green' : 'red',
              fontWeight: passwordValidation.uppercase ? 'bold' : 'normal',
              lineHeight: 1.4
            }}
          >
            At least {policyConstraints.minUppercase} uppercase letters
          </Typography>
        </Box>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 1,
          borderRadius: 1,
          backgroundColor: passwordValidation.lowercase ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)'
        }}>
          {passwordValidation.lowercase ? (
            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, flexShrink: 0 }} />
          ) : (
            <CancelIcon sx={{ color: 'red', fontSize: 20, flexShrink: 0 }} />
          )}
          <Typography
            variant="body2"
            sx={{
              color: passwordValidation.lowercase ? 'green' : 'red',
              fontWeight: passwordValidation.lowercase ? 'bold' : 'normal',
              lineHeight: 1.4
            }}
          >
            At least {policyConstraints.minLowercase} lowercase letters
          </Typography>
        </Box>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 1,
          borderRadius: 1,
          backgroundColor: passwordValidation.number ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)'
        }}>
          {passwordValidation.number ? (
            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, flexShrink: 0 }} />
          ) : (
            <CancelIcon sx={{ color: 'red', fontSize: 20, flexShrink: 0 }} />
          )}
          <Typography
            variant="body2"
            sx={{
              color: passwordValidation.number ? 'green' : 'red',
              fontWeight: passwordValidation.number ? 'bold' : 'normal',
              lineHeight: 1.4
            }}
          >
            At least {policyConstraints.minNumber} numbers
          </Typography>
        </Box>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 1,
          borderRadius: 1,
          backgroundColor: passwordValidation.special ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)'
        }}>
          {passwordValidation.special ? (
            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, flexShrink: 0 }} />
          ) : (
            <CancelIcon sx={{ color: 'red', fontSize: 20, flexShrink: 0 }} />
          )}
          <Typography
            variant="body2"
            sx={{
              color: passwordValidation.special ? 'green' : 'red',
              fontWeight: passwordValidation.special ? 'bold' : 'normal',
              lineHeight: 1.4
            }}
          >
            At least {policyConstraints.minSpecial} special characters
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundImage: `url(${BG2})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {contextUserData.UserID && (
        <>
          <GujGovComp />
          <Container
            component="main"
            maxWidth="xl"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
              py: 4,
              px: { xs: 2, sm: 3, md: 4 }
            }}
          >
            <Box sx={{
              display: 'flex',
              gap: 4,
              width: '100%',
              maxWidth: 1200,
              alignItems: 'flex-start',
              flexDirection: isLg ? 'row' : 'column',
              justifyContent: 'center'
            }}>
              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  setOpenPermissionModal(true);
                }}
                sx={{
                  flex: isLg ? '0 0 500px' : '1',
                  width: isLg ? '500px' : '100%',
                  p: { xs: 3, sm: 4 },
                  mb: isMd ? 5 : 0,
                  borderRadius: 2,
                  boxShadow: 3,
                  backgroundColor: "white",
                  minHeight: 'fit-content'
                }}
              >
                {/* Header Section */}
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  mb: 3
                }}>
                  <LockResetIcon sx={{
                    fontSize: isSm ? 50 : 80,
                    color: '#1976d2',
                    mb: 1
                  }} />
                  <Typography
                    variant={isSm ? 'h5' : 'h4'}
                    align="center"
                    gutterBottom
                    sx={{ mb: 1 }}
                  >
                    Change Password
                  </Typography>
                  <Typography
                    variant="body1"
                    align="center"
                    sx={{
                      mb: 0,
                      fontWeight: 'medium'
                    }}
                  >
                    User: {contextUserData?.UserID.trim()}
                  </Typography>
                </Box>

                {/* Form Fields Section */}
                <Box sx={{ mb: 3 }}>
                  <TextField
                    fullWidth
                    label="Old Password"
                    variant="filled"
                    type="text"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    required
                    sx={{ mb: 2.5 }}
                  />
                  <TextField
                    fullWidth
                    label="New Password"
                    variant="filled"
                    type="text"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    sx={{ mb: 2.5 }}
                  />
                  <TextField
                    fullWidth
                    label="Confirm New Password"
                    variant="filled"
                    type="password"
                    value={repeatPassword}
                    onChange={(e) => setRepeatPassword(e.target.value)}
                    required
                    sx={{ mb: 0 }}
                  />
                </Box>

                {/* Password Requirements Panel - Inside form for small/medium screens */}
                {!isLg && (
                  <Box sx={{ mb: 3 }}>
                    <PasswordValidationRules />
                  </Box>
                )}

                {/* Buttons Section */}
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 2,
                  flexWrap: isSm ? 'wrap' : 'nowrap'
                }}>
                  <Button
                    onClick={() => history.push("/home")}
                    variant="contained"
                    color="error"
                    startIcon={<HomeIcon />}
                    sx={{
                      flex: isSm ? '1 1 100%' : '1 1 0',
                      minWidth: isSm ? '100%' : 'auto',
                      py: 1.2,
                      px: 2,
                      textTransform: 'none',
                      borderRadius: 1,
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: 3,
                      },
                      order: isSm ? 3 : 1
                    }}
                  >
                    Home
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleReset}
                    sx={{
                      flex: isSm ? '1 1 48%' : '1 1 0',
                      minWidth: isSm ? '48%' : 'auto',
                      py: 1.2,
                      px: 2,
                      borderRadius: 1,
                      textTransform: 'none',
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: 3,
                      },
                      order: isSm ? 1 : 2
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    disabled={loading}
                    sx={{
                      flex: isSm ? '1 1 48%' : '1 1 0',
                      minWidth: isSm ? '48%' : 'auto',
                      py: 1.2,
                      px: 2,
                      borderRadius: 1,
                      textTransform: 'none',
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: 3,
                      },
                      order: isSm ? 2 : 3
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Confirm"
                    )}
                  </Button>
                </Box>

                {/* Password Requirements Panel - Right Side */}

              </Box>
              {/* Password Requirements Panel - Right side for large screens only */}
              {isLg && (
                <Box sx={{
                  flex: '0 0 450px',
                  width: '450px',
                  p: { xs: 3, sm: 4 },
                  borderRadius: 2,
                  boxShadow: 3,
                  backgroundColor: "white",
                  position: 'sticky',
                  top: 20,
                  alignSelf: 'center',
                  minHeight: 'fit-content'
                }}>
                  <PasswordValidationRules />
                </Box>
              )}
              <PermissionAlert
                open={openPermissionModal}
                onClose={setOpenPermissionModal}
                question={"Are you sure you want to change the password?"}
                confirmFlag={(flag) => {
                  if (flag) { handleSubmit(); }
                }}
              />
            </Box>
          </Container>
        </>
      )}
    </Box>
  );
};

export default ChangePassword;